/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_TitleInputs */

const vi_invoice_misa_template_title = /** @type {(inputs: Invoice_Misa_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu hóa đơn MISA`)
};

/**

* @param {Invoice_Misa_Template_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_title = /** @type {((inputs?: Invoice_Misa_Template_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_title(inputs)
});